import { t } from '@hefe/i18n';
import {
  currentSeasonEndDate,
  currentSeasonStartDate,
  dateFormat,
} from '@hefe/utils';
import { Card, Col, DatePicker, Row, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import BasketballGameStatisticsComponent from '../../components/basketball-games-stats/basketball-games-stats.component';
import BasketballPracticesStatisticsComponent from '../../components/basketball-practices-stats/basketball-practices-stats.component';
import TasksStatisticsComponent from '../../components/tasks-stats/tasks-stats.component';
import UsersStatisticsComponent from '../../components/users-stats/users-stats.component';

export default function StatisticsPage() {
  const [dateFrom, setDateFrom] = useState<dayjs.Dayjs>(
    currentSeasonStartDate()
  );
  const [dateTill, setDateTill] = useState<dayjs.Dayjs>(currentSeasonEndDate());
  const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs]>([
    dateFrom,
    dateTill,
  ]);

  return (
    <>
      <Row>
        <Col xs={24}>
          <Space>
            <Typography.Text>
              {t('statistics.date_range.title')}:
            </Typography.Text>
            <DatePicker.RangePicker
              format={dateFormat()}
              defaultValue={[dateFrom, dateTill]}
              value={[dateFrom, dateTill]}
              onOpenChange={(open) => {
                if (!open) {
                  setDateRange([dateFrom, dateTill]);
                }
              }}
              onCalendarChange={(values) => {
                if (values?.[0]) {
                  setDateFrom(dayjs(values[0]));
                }
                if (values?.[1]) {
                  setDateTill(dayjs(values[1]));
                }
              }}
            />
          </Space>
        </Col>
      </Row>
      <Row style={{ marginTop: 24 }} gutter={[16, 16]}>
        <Col xs={24} md={24} lg={12}>
          <Card title={t('statistics.games.title')}>
            <BasketballGameStatisticsComponent
              from={dateRange[0].format('YYYY-MM-DD')}
              till={dateRange[1].format('YYYY-MM-DD')}
            />
          </Card>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <Card title={t('statistics.practices.title')}>
            <BasketballPracticesStatisticsComponent
              from={dateRange[0].format('YYYY-MM-DD')}
              till={dateRange[1].format('YYYY-MM-DD')}
            />
          </Card>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <Card title={t('statistics.tasks.title')}>
            <TasksStatisticsComponent
              from={dateRange[0].format('YYYY-MM-DD')}
              till={dateRange[1].format('YYYY-MM-DD')}
            />
          </Card>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <Card title={t('statistics.users.title')}>
            <UsersStatisticsComponent />
          </Card>
        </Col>
      </Row>
    </>
  );
}
